import React, { useEffect, useState } from 'react';
import { VipService } from '../services';
import moment from 'moment';
import VipStockInfo from '@pages/contacts/body/VipStockInfo';

export const useVipContactList = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    VipService.fetch().then(response => {
      const tableData = response.map(
        ({ createDt, userName, phoneNumber, description, stockInfo }) => {
          return [
            moment(createDt).format('YY.MM.DD HH:mm'),
            userName,
            phoneNumber,
            description,
            <VipStockInfo stockInfo={stockInfo} />
          ];
        }
      );

      setData(tableData);
    });
  }, []);

  return {
    headers: ['요청일자', '이름', '연락처', '자본금', '보유종목'],
    data
  };
};

